module.exports = __webpack_public_path__ + "media/images/salon-frame-b89a2c37a8286b09fbdfbf8a23798f15.svg";